module.exports = __webpack_public_path__ + "img/dcmm_6.892be1f8.png";